<script>
  export let name;
  export let renaming;
  export let onChange = () => {};

  const originalValue = name;

  let inputRef = null;

  const onKeyUp = (e) => {
    if (e.code === 'Enter') {
      onChange(name);
    }

    if (e.code === 'Escape') {
      renaming = false;
      name = originalValue;
    }
  };

  const onInput = () => {
    onChange(name);
  };

  $: renaming && inputRef?.focus();
</script>

{#if !renaming}
  {name}
{:else}
  <input bind:this={inputRef} type="text" bind:value={name} on:keyup={onKeyUp} on:change={onInput} />
{/if}

<style lang="scss" src="./name.scss"></style>
